import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M822.455512,787.785569 L855.793458,787.785569 L855.793458,1235.00525 L1024.59318,1235.00525 L1024.59318,168.889606 L1221.24486,168.889606 L1221.24486,1235.00525 L1390.04459,1235.00525 L1390.04459,168.889606 L1561.37631,168.889606 L1561.37631,0 L822.455512,0 C605.379066,0 428.730154,176.658528 428.730154,393.850562 C428.730154,611.127041 605.379066,787.785569 822.455512,787.785569 M1771.984,1438.17535 L523.26841,1438.17535 L716.918136,1244.58434 L597.502212,1125.20462 L199.984,1522.60231 L597.502212,1920 L716.918136,1800.62028 L523.26841,1607.02927 L1771.984,1607.02927 L1771.984,1438.17535 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTextDirectionRtlSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTextDirectionRtlSolid, _Component);

  var _super = _createSuper(IconTextDirectionRtlSolid);

  function IconTextDirectionRtlSolid() {
    _classCallCheck(this, IconTextDirectionRtlSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTextDirectionRtlSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTextDirectionRtl",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTextDirectionRtlSolid.displayName = "IconTextDirectionRtlSolid";
  return IconTextDirectionRtlSolid;
}(Component);

IconTextDirectionRtlSolid.glyphName = 'text-direction-rtl';
IconTextDirectionRtlSolid.variant = 'Solid';
IconTextDirectionRtlSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTextDirectionRtlSolid;
export { IconTextDirectionRtlSolid };